import { useState } from 'react'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import ListItemText from '@mui/material/ListItemText'
import Avatar from '@mui/material/Avatar'
import Tooltip from '@mui/material/Tooltip'
import { useTranslation } from 'react-i18next'
import LanguageIcon from '@mui/icons-material/Language';
import useLanguage from '@/hooks/useLanguage';

export default function LanguageSwitcher() {
  const { t } = useTranslation();
  const {
    currentLanguageCode,
    langaugesList,
    setLanguage,
  } = useLanguage();
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  
  const onChange = (code) => {
    setLanguage(code);
    setAnchorEl(null)
  }

  return (
    <>
      <Tooltip 
        title={t('language')}
        placement='top-start'
      >
        <IconButton 
          onClick={(e) => setAnchorEl(e.currentTarget)}
        >
          <LanguageIcon />
        </IconButton>
      </Tooltip>
      <Menu
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ 
          vertical: 'bottom',
          horizontal: 'right', 
        }}
        transformOrigin={{ 
          vertical: 'bottom',
          horizontal: 'left', 
        }}
      >
        {
          langaugesList.map((lang) => (
            <MenuItem
              key={lang.code}
              onClick={() => onChange(lang.code)}
              selected={lang.code === currentLanguageCode}
            >
              <ListItemIcon>
                <Avatar
                  src={lang.flagImg}
                  alt={lang.code}
                  sx={{ width: 18, height: 18 }}
                />
              </ListItemIcon>
              <ListItemText>{lang.label}</ListItemText>
            </MenuItem>
          ))
        }
      </Menu>
    </>
  )
}
